export const TWILIO_IP_RANGES = [
    "13.210.2.128/27",
    "54.252.254.64/26",
    "3.25.42.128/25",
    "18.231.105.32/27",
    "177.71.206.192/26",
    "18.230.125.0/25",
    "52.59.186.0/27",
    "18.195.48.224/27",
    "18.156.18.128/25",
    "52.66.193.96/27",
    "52.66.194.0/26",
    "3.7.35.128/25",
    "52.215.253.0/26",
    "54.171.127.192/26",
    "52.215.127.0/24",
    "3.249.63.128/25",
    "13.115.244.0/27",
    "54.65.63.192/26",
    "18.180.220.128/25",
    "13.229.255.0/27",
    "54.169.127.128/26",
    "18.141.157.128/25",
    "34.203.254.0/24",
    "54.172.60.0/23",
    "34.203.250.0/23",
    "3.235.111.128/25",
    "34.216.110.128/27",
    "54.244.51.0/24",
    "44.234.69.0/25",
];
//# sourceMappingURL=TWILIO_IP_RANGES.js.map